import { ViewUpdateEvent } from '../view/events/ViewUpdateEvent';

/**
 * Event handler result types inform EventHandler the result of an action.
 */
export enum EventHandlerResultType {
    EVENT_HANDLED, //EVENT_HANDLED, event was successfully handled by the EventHandler
    EVENT_NOT_HANDLED, //EVENT_NOT_HANDLED, event was not handled by the EventHandler, it should be propagated further
}

/**
 * EventHandlerResult are used to convey EventHandler's response to event provided by ToolManager.
 * EventHandlerResult may be used to inform about a new action that the event initiated.
 * It may also be used to inform about the completion of the previous action.
 * It is also used to determine whether ToolManager should continue event propagation or not.
 */
export class EventHandlerResult {
    /**
     * The type of the event handler result.
     * This controls how the EventHandler should react to EventHandler's response
     */
    public readonly type: EventHandlerResultType;

    /**
     * Boolean flag that will indicate whether the propagation should end as a result
     * of handling the event
     */
    public readonly stopPropagation: boolean;

    public readonly viewUpdateEvent?: ViewUpdateEvent;

    public constructor(
        type: EventHandlerResultType,
        stopPropagation?: boolean,
        viewUpdateEvent?: ViewUpdateEvent
    ) {
        this.type = type;
        this.stopPropagation =
            stopPropagation === undefined
                ? type !== EventHandlerResultType.EVENT_NOT_HANDLED
                : stopPropagation;
        this.viewUpdateEvent = viewUpdateEvent;
    }
}
